import { render } from "./NarrowNav.vue?vue&type=template&id=b4d9d74a"
import script from "./NarrowNav.vue?vue&type=script&lang=js"
export * from "./NarrowNav.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__